import { GraphDataRecord } from '@Types/peek';

type ParsedPeekDataObj = {
	datetime: string;
	value: number;
};

export type RawQueryData = Array<Array<string | number>>;

// * Meant to transform data peek results (connector raw data) to graph compatible scheme
export class PeekDataParser {
	public static parsePeekDataToObj(
		rawQueryData: RawQueryData,
	): ParsedPeekDataObj[] {
		if (rawQueryData.length <= 1) return [];
		const [keys, ...datPointTuples] = rawQueryData; // ? first element of array (header fields)
		const remapped = datPointTuples.reduce<ParsedPeekDataObj[]>(
			(acc, cur) => {
				const record: Record<string, unknown> = {};
				keys.forEach((key, idx) => {
					record[key] = cur[idx];
				});
				acc.push(record as ParsedPeekDataObj);
				return acc;
			},
			[],
		);
		return remapped;
	}

	public static parseDataToGraphRecord(
		rawQueryData: RawQueryData,
	): GraphDataRecord[] {
		const remapped = this.parsePeekDataToObj(
			rawQueryData,
		).map<GraphDataRecord>(el => ({
			ts: new Date(el.datetime).getTime(),
			value: el.value,
		}));
		return remapped;
	}
}
